export enum PageTypeEnum {
  DsCheckoutPage = 'DS_CHECKOUT_PAGE',
  Squeeze = 'squeeze',
  SalesPage = 'sales_page',
  InfoPage = 'info_page',
  Inline = 'inline',
  Popup = 'popup',
  OptInThankYou = 'opt_in_thank_you',
  LinkInBio = 'link_in_bio',
  CustomLogin = 'custom_login',
  NotFound = 'not_found',
  Lecture = 'lecture',
  WebinarThankYouPage = 'webinar_thank_you_page',
  WebinarRegistration = 'webinar_registration',
  WebinarSession = 'webinar_session',
  OfferThankYouPage = 'offer_thank_you_page',
  OfferPage = 'offer_page',
  OfferInner = 'offer_inner',
  OfferInnerThankYou = 'offer_inner_thank_you',
  OfferUpsellPage = 'offer_upsell_page',
  InactiveFunnelPage = 'inactive_funnel_page',
  FunnelContactUs = 'funnel_contact_us',
  BlogPostBody = 'blog_post_body',
  BlogStatic = 'blog_static',
  BlogHome = 'blog_home',
  BlogLayout = 'blog_layout',
  BlogPostLayout = 'blog_post_layout',
  BlogPostListing = 'blog_post_listing',
  BlogSearch = 'blog_search',
  WebsiteHome = 'WebsiteHome',
  WebsiteDefault = 'WebsiteDefault',
  WebsiteLayout = 'WebsiteLayout',
  WebsitePricing = 'WebsitePricing',
  WebsiteLogin = 'WebsiteLogin',
}

export const pageTypeTitlesLocoKeys = {
  [PageTypeEnum.DsCheckoutPage]: 'dashboard.contact_page.page.ds_checkout_page',
  [PageTypeEnum.Squeeze]: 'dashboard.contact_page.page.squeeze',
  [PageTypeEnum.SalesPage]: 'dashboard.contact_page.page.sales_page',
  [PageTypeEnum.InfoPage]: 'dashboard.contact_page.page.info_page',
  [PageTypeEnum.Inline]: 'dashboard.contact_page.page.inline',
  [PageTypeEnum.Popup]: 'dashboard.contact_page.page.popup',
  [PageTypeEnum.OptInThankYou]: 'dashboard.contact_page.page.opt_in_thank_you',
  [PageTypeEnum.LinkInBio]: 'dashboard.contact_page.page.link_in_bio',
  [PageTypeEnum.CustomLogin]: 'dashboard.contact_page.page.custom_login',
  [PageTypeEnum.NotFound]: 'dashboard.contact_page.page.not_found',
  [PageTypeEnum.Lecture]: 'dashboard.contact_page.page.lecture',
  [PageTypeEnum.WebinarThankYouPage]: 'dashboard.contact_page.page.webinar_thank_you_page',
  [PageTypeEnum.WebinarRegistration]: 'dashboard.contact_page.page.webinar_registration',
  [PageTypeEnum.WebinarSession]: 'dashboard.contact_page.page.webinar_session',
  [PageTypeEnum.OfferThankYouPage]: 'dashboard.contact_page.page.offer_thank_you_page',
  [PageTypeEnum.OfferPage]: 'dashboard.contact_page.page.offer_page',
  [PageTypeEnum.OfferInner]: 'dashboard.contact_page.page.offer_inner',
  [PageTypeEnum.OfferInnerThankYou]: 'dashboard.contact_page.page.offer_inner_thank_you',
  [PageTypeEnum.OfferUpsellPage]: 'dashboard.contact_page.page.offer_upsell_page',
  [PageTypeEnum.InactiveFunnelPage]: 'dashboard.contact_page.page.inactive_funnel_page',
  [PageTypeEnum.FunnelContactUs]: 'dashboard.contact_page.page.funnel_contact_us',
  [PageTypeEnum.BlogPostBody]: 'dashboard.contact_page.page.blog_post_body',
  [PageTypeEnum.BlogStatic]: 'dashboard.contact_page.page.blog_static',
  [PageTypeEnum.BlogHome]: 'dashboard.contact_page.page.blog_home',
  [PageTypeEnum.BlogLayout]: 'dashboard.contact_page.page.blog_layout',
  [PageTypeEnum.BlogPostLayout]: 'dashboard.contact_page.page.blog_post_layout',
  [PageTypeEnum.BlogPostListing]: 'dashboard.contact_page.page.blog_post_listing',
  [PageTypeEnum.BlogSearch]: 'dashboard.contact_page.page.blog_search',
  [PageTypeEnum.WebsiteHome]: 'dashboard.contact_page.page.website_home',
  [PageTypeEnum.WebsiteDefault]: 'dashboard.contact_page.page.website_default',
  [PageTypeEnum.WebsiteLayout]: 'dashboard.contact_page.page.website_layout',
  [PageTypeEnum.WebsitePricing]: 'dashboard.contact_page.page.website_pricing',
  [PageTypeEnum.WebsiteLogin]: 'dashboard.contact_page.page.website_login',
} satisfies Record<PageTypeEnum, string>;
